import { AppCategory } from '../types';

/**
 * Checks if an app should show the "Coming Soon" message.
 * Returns true if:
 * - App is an entitled app
 * - App has no moduleRoutes defined (empty moduleRoutes array) or no moduleRoutes property
 * - App has no component property
 */
export function shouldShowComingSoon(app: {
  category: AppCategory;
  moduleRoutes?: unknown;
  component?: unknown;
  externalUrl?: string;
  openInNewTab?: boolean;
}): boolean {
  // Only show for entitled apps
  if (app.category !== AppCategory.ENTITLED) {
    return false;
  }

  // Must not have a component (if it has a component, it would render as a local page)
  if ('component' in app && app.component) {
    return false;
  }

  // Check if moduleRoutes is missing or empty array
  if ((!('moduleRoutes' in app) || !app.moduleRoutes) && !app.externalUrl && !app.openInNewTab) {
    return true;
  }

  // Check if moduleRoutes is an array and has at least one route
  if (
    Array.isArray(app.moduleRoutes) &&
    app.moduleRoutes.length === 0 &&
    !app.externalUrl &&
    !app.openInNewTab
  ) {
    return true;
  }

  // App has moduleRoutes defined, so it should not show "Coming Soon"
  return false;
}
